import React from "react";
import { Text4 } from "../../../../styles";
import { printRupee } from "../../../../app_methods";
import moment from "moment";
import { Badge, Icon, Button, Menu, Dropdown } from "antd";
import { VENDOR_APPROVAL_STATUS, VENDOR_INVOICE_STATUS_TYPES } from "../../../../constants";
import { PermissionHoc } from "../../../HOC";

const PermissableMenuItem = PermissionHoc(Menu.Item, "", {
  is_component: true,
  fallbackComponent: null,
});

export const renderMenuOverlay = (methods, record) => {
  console.log("record", record);
  return (
    <Menu>
      <PermissableMenuItem
        required_permission="VENDOR_INVOICE_READ"
        className="mr-1"
        size="small"
        onClick={() => methods.toggleVendorInvoiceDetailsDrawer({ ...record })}
      >
        View Details
      </PermissableMenuItem>
      {(record.vendor && VENDOR_APPROVAL_STATUS[record.vendor.status].label == "Active") ? (
        <PermissableMenuItem
          required_permission="VENDOR_INVOICE_WRITE"
          className="mr-1"
          size="small"
          disabled={(record.status == 'unpaid' || record.status == "unapproved") ? false : true}
          onClick={() => methods.toggleVendorInvoiceModal({ ...record, is_edit: true })}
        >
          Edit
        </PermissableMenuItem>
      ) : null}
    </Menu>
  );
};

export const getVendorInvoiceColumns = (methods, current_user) => [
  {
    title: "Invoice Number",
    key: "invoice_number",
    render: (record) => <Text4>{record.number || "---"}</Text4>,
  },
  {
    title: "Vendor Name",
    key: "vendor_name",
    render: (record) => <Text4>{record.vendor.name || "---"}</Text4>,
  },
  {
    title: "Issue Date",
    key: "invoice_date",
    render: (record) => (
      <Text4>
        {record.issue_date ? moment(record.issue_date).format("LL") : "---"}
      </Text4>
    ),
  },
  {
    title: "Due Date",
    key: "due_date",
    render: (record) => (
      <Text4>
        {record.due_date ? moment(record.due_date).format("LL") : "---"}
      </Text4>
    ),
  },
  {
    title: "Payable Amount",
    key: "total_amount",
    render: (record) => <Text4>{printRupee(record.total_amount || "---")}</Text4>,
  },
  {
    title: (
      <span className="c-pointer" onClick={methods.toggleStatusInfoDrawer}>
        <span>Invoice Status</span>
        <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
      </span>
    ),
    key: "payment_status",
    render: (record) => (
      <Badge
        color={VENDOR_INVOICE_STATUS_TYPES[record.status].color}
        text={<Text4>{VENDOR_INVOICE_STATUS_TYPES[record.status].label}</Text4>}
      />
    ),
  },
  {
    title: "Action",
    key: "action",
    render: (record) => (
      <Dropdown overlay={renderMenuOverlay(methods, record)}>
        <Button>
          Actions <Icon type="down" />
        </Button>
      </Dropdown>
    ),
  },
];

export const vendorInvoiceTableFilterNodes = (params = {}) => {
  let vendor = params.vendor;

  return [
    {
      label: "Vendor Name",
      field: "vendor_name",
      placeholder: "Vendor Name",
      inputType: "text",
      width: 200,
      disabled: false,
      defaultValue: undefined,
    },
    {
      label: "Invoice Number",
      field: "number",
      placeholder: "Invoice Number",
      inputType: "text",
      defaultValue: undefined,
    },
    {
      label: "Status",
      field: "status",
      placeholder: "Status",
      inputType: "select",
      defaultValue: undefined,
      options: Object.keys(VENDOR_INVOICE_STATUS_TYPES).map((type, index) => {
        let object = {};
        object.key = index;
        object.value = VENDOR_INVOICE_STATUS_TYPES[type].value;
        object.label = (
          <Badge
            color={VENDOR_INVOICE_STATUS_TYPES[type].color}
            text={<Text4>{VENDOR_INVOICE_STATUS_TYPES[type].label}</Text4>}
          />
        );
        return object;
      }),
    },
  ];
};
